import type { AxiosInstance } from "axios";
import { MESSAGE_PAGE_SIZE } from "./thread/useEarlierMessages";
import { noteSnapshotRequest } from "./sessionOpenTiming";
import { rememberSubSessionStatuses } from "@/components/agent-session/subSessionAnswers";
import { payloadDiffAccessGeneration } from "@/components/agent-session/workspace-pane/sessionPayloadDiffAccess";

// Kept free of transformSession so AuthProvider's deep-link prefetch can
// start the request without pulling the parser into the root bundle.

/** Matches hover prefetch, so a click inside the window never refetches. */
export const ASSISTANT_SESSION_STALE_TIME_MS = 30_000;
/** Opened sessions stay warm so sidebar switching skips the skeleton. */
export const ASSISTANT_SESSION_CACHE_TIME_MS = 15 * 60 * 1000;

export function assistantSessionQueryKey(sessionId: string) {
  return ["assistantSession", sessionId] as const;
}

/** The windowed snapshot the thread renders from, unparsed, with the diff access generation `parseSessionResponse` takes. */
export async function requestAssistantSession(
  api: AxiosInstance,
  sessionId: string,
) {
  noteSnapshotRequest(sessionId);
  const requestedAt = Date.now();
  const diffAccessGeneration = payloadDiffAccessGeneration(sessionId);
  const response = await api.get<unknown>(`/assistant/sessions/${sessionId}`, {
    params: { limit: MESSAGE_PAGE_SIZE },
  });
  // Before the thread mounts, so its sub-session cards paint their status rows with it.
  rememberSubSessionStatuses(response.data, requestedAt);
  return { data: response.data, diffAccessGeneration };
}
